import React from 'react';
import { BillingPlan } from '../billingPlans';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';
import { Reactivation } from './Reactivation';

const BILLING_CONTAINER_ID = 'billing';
const OFFER_CONTAINER_ID = 'offer';

export const ReactivationBanner = (props: { billingPlan: BillingPlan; offer: string | null }) => {
  const { billingPlan, offer } = props;

  useAnalyticsPage(Page.REACTIVATION_BANNER, { offer: offer ? offer : undefined });

  return (
    <>
      <div className="billing__reactivation-container" id={OFFER_CONTAINER_ID}>
        <div className="flex-grow-1">
          <Reactivation billingPlan={billingPlan} offer={offer} />
        </div>
        <div className="billing__reactivation-banner-links">
          <a href={`#${BILLING_CONTAINER_ID}`}>↓ View your invoices and billing details ↓</a>
        </div>
      </div>
      <div className="billing__reactivation-banner-links text-center" id={BILLING_CONTAINER_ID}>
        <a href={`#${OFFER_CONTAINER_ID}`}>↑ View special offer ↑</a>
      </div>
    </>
  );
};
